<template>
    <ml-layout title="实践教学管理平台" :nav="nav">
        <div class="ml-main">
            <ml-column title="实验列表" class="column">
                项目名称：
                <el-input
                    size="mini"
                    placeholder="项目名称"
                    class="search"
                    v-model="search.title"
                ></el-input>
                负责人姓名：
                <el-input
                    size="mini"
                    placeholder="负责人姓名"
                    class="search"
                    v-model="search.fuzeren"
                ></el-input>
                <el-button
                    type="primary"
                    size="mini"
                    class="search-button"
                    @click="handleSearch"
                >
                    搜索
                </el-button>
            </ml-column>
            <br />
            <div v-loading="loading">
                <el-row v-for="i in parseInt(count / 3) + 1" :key="i">
                    <el-col :span="8" v-for="j in 3" :key="j">
                        <ml-card
                            v-if="[(i - 1) * 3 + j - 1] < info.length"
                            :info="info[(i - 1) * 3 + j - 1]"
                        ></ml-card>
                    </el-col>
                </el-row>
            </div>
            <br />
            <el-pagination
                v-if="!loading"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[9, 12, 24, 30]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="count"
            >
            </el-pagination>
        </div>
    </ml-layout>
</template>

<script>
import { showVirtualSimulation } from "@/api/views/virtualExp";

import MlLayout from "@/components/MlLayout";
import MlCard from "@/components/MlCard";
import MlColumn from "@/components/MlColumn";

export default {
    name: "VirtualExp",
    components: {
        MlCard,
        MlLayout,
        MlColumn
    },
    data() {
        return {
            nav: [
                { title: "首页", path: ["/"] },
                { title: "虚拟实验", path: ["/virtualExp", "/declareExp"] }
            ],
            // 数量
            count: 0,
            page: 1,
            size: 9,

            info: [],
            search: {},
            loading: true
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        handleSearch() {
            this.loading = true;
            showVirtualSimulation(
                Object.assign(this.search, {
                    page: this.page,
                    showNum: this.size,
                    order: "expVisitCount"
                })
            ).then(res => {
                this.info = [];
                res.virtualList.forEach(item => {
                    let jump_url = null;

                    if (item.jump_url) {
                        jump_url =
                            item.jump_url +
                            (item.jump_url.indexOf("?") == -1 ? "?" : "&");

                        let interfaceUrl =
                            "http://sjjx.dlou.edu.cn/exp/uploadExpData";
                        if (item.version == 2) {
                            interfaceUrl =
                                "http://sjjx.dlou.edu.cn/exp/v2/uploadExpData";
                        }

                        jump_url +=
                            "expId=" +
                            encodeURI(item.exp_id) +
                            "&userId=" +
                            encodeURI(
                                this.$store.state.userInfo.cryptId || ""
                            ) +
                            "&url=" +
                            encodeURI(interfaceUrl);
                    }

                    this.info.push({
                        id: item.id,
                        imageUrl:
                            item.video_img ||
                            "http://sjjx.dlou.edu.cn/uploads/default.png",
                        title: item.exp_name || item.title,
                        school: item.school_name,
                        leader: item.fuzeren,
                        count: item.expVisitCount,
                        jump_url: jump_url
                    });
                });
                this.loading = false;

                this.count = parseInt(res.count);
            });
        },
        handleSizeChange(size) {
            this.size = size;
            this.handleSearch();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.handleSearch();
        }
    }
};
</script>

<style lang="scss" scoped>
.ml-card {
    margin: 8px;
}

.search {
    width: 200px;
    margin-right: 8px;
}

.search-button {
    margin-left: 20px;
}
</style>
